__turbopack_context__.v({
  "announcementCard": "LandingPageMBAPageCard-module-scss-module__chnEea__announcementCard",
  "announcementCardBack": "LandingPageMBAPageCard-module-scss-module__chnEea__announcementCardBack",
  "announcementImg": "LandingPageMBAPageCard-module-scss-module__chnEea__announcementImg",
  "announcementInner": "LandingPageMBAPageCard-module-scss-module__chnEea__announcementInner",
  "announcementItem": "LandingPageMBAPageCard-module-scss-module__chnEea__announcementItem",
  "announcementSubtitle": "LandingPageMBAPageCard-module-scss-module__chnEea__announcementSubtitle",
  "announcementTitle": "LandingPageMBAPageCard-module-scss-module__chnEea__announcementTitle",
  "backSide": "LandingPageMBAPageCard-module-scss-module__chnEea__backSide",
  "border": "LandingPageMBAPageCard-module-scss-module__chnEea__border",
  "content": "LandingPageMBAPageCard-module-scss-module__chnEea__content",
  "contentParent": "LandingPageMBAPageCard-module-scss-module__chnEea__contentParent",
  "descriptionDiv": "LandingPageMBAPageCard-module-scss-module__chnEea__descriptionDiv",
  "flip": "LandingPageMBAPageCard-module-scss-module__chnEea__flip",
  "frontSide": "LandingPageMBAPageCard-module-scss-module__chnEea__frontSide",
  "isScholarshipCard": "LandingPageMBAPageCard-module-scss-module__chnEea__isScholarshipCard",
  "root": "LandingPageMBAPageCard-module-scss-module__chnEea__root",
  "title": "LandingPageMBAPageCard-module-scss-module__chnEea__title",
  "titleDescription": "LandingPageMBAPageCard-module-scss-module__chnEea__titleDescription",
  "titleWithSubtitle": "LandingPageMBAPageCard-module-scss-module__chnEea__titleWithSubtitle",
  "underDesc": "LandingPageMBAPageCard-module-scss-module__chnEea__underDesc",
  "visibility": "LandingPageMBAPageCard-module-scss-module__chnEea__visibility",
});
